import React, { useEffect, useState } from 'react'
import UserHero from '../../userPages/partials/UserHero'
import ListGroup from '../../userPages/partials/ListGroup'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { FaForward } from 'react-icons/fa'
import UserAccount from '../../userPages/partials/UserAccount'
import FormValidation from '../../validators/Formvalidators'
import imgageValidation from "../../validators/Imagevalidators"

export default function UpdateGallery() {
    let [data, setData] = useState({
      name:"",
        pic:"",
    })
    let {_id} = useParams()

    
    let [oldPic , setOldPic] = useState([])
    let [flag , setFlag] = useState(false)
   let navigate = useNavigate()
    let [show, setShow]=useState(false)
    let [errorMessage, setErrorMessage]=useState({
     
      name: "",
      pic: "",
    })
  const getInputData=(e)=>{
    let name= e.target.name;
    // let value =e.target.files? e.target.files[0]:e.target.value;
    let value = e.target.files ? e.target?.files: e.target.value;
    if(name ==="name" || name==="pic"){
     setErrorMessage((old)=>{
      return{
        ...old,
      [name]:e.target.files ? imgageValidation(e):FormValidation(e)
      }
     })
     setData((old)=>{
      return{
        ...old,
        [name]:value
      }
     })
  }
}

  async function postData(e){
    e.preventDefault()
   
    
    let error = Object.values(errorMessage).find((x)=>x?.length > 0)
    if(error){
      setShow(true)
    }
    else{
     
      if(data){
  
        let newData = [data]
        // let item = Array.isArray(data) ? data.find((x)=> x.name.toLowerCase()===data.name.toLowerCase()  ):null
        let item = newData.find((x)=>x.name?.toLowerCase() === data.name.toLowerCase() && x._id !== _id)
        if(item){
          setErrorMessage((old)=>{
            return{
              ...old,
              'name':"Name is Already Exits "
            }
          })
        }
        
        else{
        

           let formData = new FormData()
           formData.append("name", data.name)
          //  formData.append("pic", data.pic)
          
           formData.append("oldPic" ,oldPic)
           Array.from(data.pic).forEach((p)=>{
                 formData.append("pic" , p)
           })
          let response = await fetch ("http://34.228.14.188:8000/api/gallery/"+_id,{
            method:"PUT",
            body: formData
          })
          response = await response.json()
          
          if(response.result === "Done")
            navigate("/admin/gallery")
          else
        alert("something went wrong")

        }
       
      }

      else{
        
      }
     
    }

  }

  async function getApiData() {
    let response = await fetch( "http://34.228.14.188:8000/api/gallery/"+_id , {
           method :"GET",
           headers:{
            "content-type":"application/json",
            // "authorization":localStorage.getItem("token")
                  }
    })

    response = await response.json()
    
    if(response.result = "Done"){
      let item =   response.data
      // (response.data);
      setData(item)
      setOldPic(item.pic)

    }
    else
setData([])
    
}
useEffect(()=>{
    getApiData()
} ,[data.length])

  return (
   <>
   <UserHero/>

   <div className="container">
           <div className="container-fluid mt-3">
            <UserAccount/>
               <div className="row">
               <ListGroup/>
                  <div className="col-md-8">
                  <div className="admin-heading">
                  <h3>UPDATE GALLERY <Link to="/my-account"><FaForward  className='float-end mx-2 ' /></Link> </h3>:
                           
                       </div>
                       <form  onSubmit={postData}>
                    <div className="row">
                    <div className="col-md-6 mt-3">
                        <label for="exampleFormControlInput1"  className="form-label">Name*</label>
                        <input type="text" name='name'  value={data.name} onChange={getInputData}  className="form-control" id="exampleFormControlInput1" placeholder="Room Type Name"/>
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.name}</p>:""}
                      </div>
                      
                    </div>

                     <div className="row">
                <div className="col-md-6 mb-3">
                  <label>Pic*</label>
                  <input
                    type="file"
                    name="pic"
                    multiple
                    
                    onChange={getInputData}
                    className="form-control border-primary border-2"
                  />
                  {show && errorMessage.pic ? (
                    <p className="text-danger text-capitalize">
                      {errorMessage.pic}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-6 mb-3">
<label>Click on Image to Remove Old Image</label><br />
{
  oldPic?.map((item,index)=>{
    return <img src={`http://34.228.14.188:8000${item}`} key={index}  height={50} width={50}  alt="image"  
    onClick={()=>{
      oldPic.splice(index,1)
      setFlag(!flag)
    }} />
  })
}

</div>
</div>

                       <div className="admmin-update mb-5">
                           <button className='w-100 btn-primary' type='submit'>UPDATE</button>
                       </div>
                     </form> 
                  </div>
               </div>
           </div>
          </div>
   </>
  )
}
